/**
 * ฟังก์ชันสำหรับคัดลอกข้อความที่ระบุไปยังคลิปบอร์ดของผู้ใช้
 * โดยใช้ document.execCommand('copy') ซึ่งรองรับใน iFrame.
 *
 * @param {string} textToCopy - ข้อความที่ต้องการคัดลอก
 * @returns {boolean} - true หากคัดลอกสำเร็จ, false หากไม่สำเร็จ
 */
import moment from "moment";
import { showToast } from "../utils";

export const CopyTextToClipboard = (textToCopy) => {
  if (!textToCopy || textToCopy === "") {
    showToast("warning", `Copied! : null`)
  }
  try {
    navigator?.clipboard?.writeText(textToCopy);
    if (!textToCopy) {
      return false;
    }
    showToast("success", `Copied!`);
  } catch (error) {
    console.log(error);
  }
};

/**
 * Copies a given text to the clipboard and shows a message.
 * @param {string} textToCopy - The text string to be copied.
 * @param {string} [message] - An optional message to display after copying.
 */
export const CopyDescriptionsToClipboard = (
  textToCopy,
  message = "Copied!"
) => {
  if (!navigator.clipboard) {
    // Fallback for older browsers
    const textArea = document.createElement("textarea");
    textArea.value = textToCopy;
    textArea.style.position = "fixed"; // Avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      console.log(message);
    } catch (err) {
      console.error("Failed to copy text", err);
    }
    document.body.removeChild(textArea);
    return;
  }

  // Modern method using the Clipboard API
  navigator.clipboard
    .writeText(textToCopy)
    .then(() => {
      showToast("success", message);
    })
    .catch((err) => {
      console.error("Failed to copy text", err);
    });
};

/**
 * คัดลอกข้อมูลจาก Descriptions
 * @param {string} nameMerchang - ข้อความที่ต้องการคัดลอก
 * @param {object} dataResults - ข้อความที่ต้องการคัดลอก
 * @param {Function} t - ข้อความที่ต้องการคัดลอก
 * @returns {void}
 */
export const handleCopyDescriptions = (dataResults, t, nameMerchang) => {
  
  if (!dataResults) {
    CopyTextToClipboard("", t("No data to copy."));
    return;
  }

  const items = this.createDescriptionsItems(dataResults, t, nameMerchang);

  const textToCopy = items
    .map((item) => {
      // ดึงค่าจาก dataResults โดยตรงโดยใช้ label
      let value = "N/A";
      switch (item.label) {
        case t("Transaction Date/Time"):
          value = dataResults?.transactionDateTime
            ? moment(dataResults.transactionDateTime).format(
                "YYYY-MM-DD HH:mm:ss"
              )
            : "-";
          break;
        case t("referenceId"):
          value = dataResults?.referenceId || "-";
          break;
        case t("platformOrderId"):
          value = dataResults?.platformOrderId || "-";
          break;
        case t("Type "):
          value = dataResults?.type || "-";
          break;
        case t("customer UUID"):
          value = dataResults?.customer_uuid || "-";
          break;
        case t("From Bank Name"):
          value = dataResults?.bankNameCustomer || "-";
          break;
        case t("From Account Name"):
          value = dataResults?.nameCustomer || "-";
          break;
        case t("From AccountNo"):
          value = dataResults?.accountCustomer || "-";
          break;
        case t("Amount "):
          value = dataResults?.amount
            ? `${Intl.NumberFormat().format(dataResults.amount)} ${
                dataResults.currency || ""
              }`
            : "-";
          break;
        case t("To Bank Account "):
          value = dataResults?.bankNameFrom || "-";
          break;
        case t("To Account Number "):
          value = dataResults?.accountFrom || "-";
          break;
        case t("To Account Name "):
          value = dataResults?.toAccountName || "-";
          break;
        case t("Status Transaction"):
          value = dataResults?.statusTrans || "-";
          break;
        case t("Merchant "):
          value =
            nameMerchang && dataResults?.merchantId
              ? `${nameMerchang} (${dataResults.merchantId})`
              : "-";
          break;
        default:
          value = "N/A";
          break;
      }
      return `${item.label}: ${value}`;
    })
    .join("\n");

  CopyTextToClipboard(textToCopy, t("Copied Details!"));
};
